export default class Customer {
    constructor(customer, cookie) {
        Object.keys(customer)
            .forEach(key => (this[key] = customer[key]));

        this.isCookiedIn = !customer.isLoggedIn && !!cookie.CustomerFirstName;
        this.hasHorse = cookie.ATSSmartPaks > 0;
        this.firstName = customer.formattedName || cookie.CustomerFirstName;
    }
}